import { createAction } from 'redux-actions'

import {
  GET_LIST,
  GET_ONE,
  CREATE,
  UPDATE,
  DELETE,
  GET_MANY,
  GET_SIMPLE,
  GET_MATCHING,
  GET_MANY_REFERENCE,
  CHECK_TEMPLATE,
  DOWNLOAD_TEMPLATE,
} from '@/state/types/data'

export const crudGetList = (resource, pagination, sort, filter, cancelPrevious = true) => ({
  type: GET_LIST,
  payload: { pagination, sort, filter },
  meta: { resource, fetch: GET_LIST, cancelPrevious },
})

export const crudGetOne = (resource, id, cancelPrevious = true) => ({
  type: GET_ONE,
  payload: { id },
  meta: { resource, fetch: GET_ONE, cancelPrevious },
})

// export const crudCreate = (resource, data, redirectTo = 'edit') => ({
export const crudCreate = (resource, data, redirectTo, { message, ...meta } = {}) => ({
  type: CREATE,
  payload: { data, redirectTo, message },
  meta: { resource, fetch: CREATE, cancelPrevious: false, ...meta },
})

export const crudUpdate = (
  resource,
  id,
  data,
  previousData,
  redirectTo,
  { message, ...meta } = {},
) => ({
  type: UPDATE,
  payload: { id, data, previousData, redirectTo, message },
  meta: { resource, fetch: UPDATE, cancelPrevious: false, ...meta },
})

export const crudDelete = (resource, id, redirectTo, { message, ...meta }) => ({
  type: DELETE,
  payload: { id, redirectTo, message },
  meta: { resource, fetch: DELETE, cancelPrevious: false },
})

// Reference related actions
export const crudGetSimple = (resource, cancelPrevious = true) => ({
  type: GET_SIMPLE,
  payload: {},
  meta: { resource, fetch: GET_SIMPLE, cancelPrevious: false },
})

// Reference related actions

export const crudGetMany = (resource, ids) => ({
  type: GET_MANY,
  payload: { ids },
  meta: { resource, fetch: GET_MANY, cancelPrevious: false },
})

export const crudGetMatching = (reference, relatedTo, pagination, sort, filter) => ({
  type: GET_MATCHING,
  payload: { pagination, sort, filter },
  meta: { resource: reference, relatedTo, fetch: GET_LIST, cancelPrevious: false },
})

export const crudGetManyReference = (
  reference,
  target,
  id,
  relatedTo,
  pagination,
  sort,
  filter,
) => ({
  type: GET_MANY_REFERENCE,
  payload: { target, id, pagination, sort, filter },
  meta: { resource: reference, relatedTo, fetch: GET_MANY_REFERENCE, cancelPrevious: false },
})

export const checkTemplate = createAction(CHECK_TEMPLATE)
export const downloadTemplate = createAction(DOWNLOAD_TEMPLATE)



// WEBPACK FOOTER //
// ./state/actions/data.js